import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import XHR from "i18next-xhr-backend";

import translationEn from "./locales/en/translation.json";
import translationEs from "./locales/es/translation.json";
import translationUa from "./locales/ua/translation.json";

i18n
  .use(XHR)
  .use(LanguageDetector)
  .init({
    debug: false,
    lng: "en",
    fallbackLng: "en",

    keySeparator: false,
    interpolation: {
      escapeValue: false,
    },

    resources: {
      en: {
        translations: translationEn,
      },
      es: {
        translations: translationEs,
      },
      ua: {
        translations: translationUa,
      },
    },
    ns: ["translations"],
    defaultNS: "translations",
  });

export const getTranslation = (key: string): string => {

    let translationData, translation;
    const lang = i18n.language;

    switch (lang) {
        case 'en':
            translationData = {...translationEn} as any;
            translation = translationData[key];
            break;
        case 'ua':
            translationData = {...translationUa} as any;
            translation = translationData[key];
            break;
        default:
            translationData = {...translationEn} as any;
            translation = translationData[key];
            break;
    }
    return translation;
};

export default i18n;
